import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const logout = () => {
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem("user");
    navigate("/login");
    toast.success("Çıkış Yapıldı");
  };

  const pulseCheck = async (token) => {
    if (!token) return logout();

    try {
      const res = await fetch(`${API_URL}/pulsecheck`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        logout();
      } else {
        const data = await res.json();
        setUser({ name: data.user.username, token });
        setIsAdmin(data.user.isAdmin);
        localStorage.setItem(
          "user",
          JSON.stringify({ name: data.user.username, token, isAdmin: data.user.isAdmin })
        );
      }
    } catch (err) {
      logout();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (storedUser?.token) pulseCheck(storedUser.token);
    }, 60 * 60 * 1000); 

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser?.token) {
      pulseCheck(storedUser.token).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    try {
      const res = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.message || "Giriş başarısız");
        return false;
      }

      setUser({ name: data.username, token: data.token });
      setIsAdmin(data.isAdmin);
      localStorage.setItem(
        "user",
        JSON.stringify({ name: data.username, token: data.token, isAdmin: data.isAdmin })
      );

      navigate("/dashboard");
      return true;
    } catch (err) {
      toast.error("Sunucu hatası");
      return false;
    }
  };

  const register = async (formData) => {
    if (!user?.token || !isAdmin) return logout();

    try {
      const res = await fetch(`${API_URL}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({ formData }),
      });

      if (!res.ok) {
        const data = await res.json();
        toast.error(data.message || "Kayıt başarısız");
        return null;
      }

      return await res.json();
    } catch (err) {
      toast.error("Sunucu hatası");
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);